// ==================== loader simple ====================
// export function globalLoaderElementSimpleStart($loader) {
//     if (!$loader) return;
// }

export function globalLoaderElementSimpleStop($loader) {
    if (!$loader) return;

    $loader.classList.add('load-complete');

    setTimeout(() => {
        $loader.classList.add('removed');
    }, 500);
}




// ==================== loader imgs ====================
export function globalLoaderElementImgsStart($loader) {
    if (!$loader) return;

    const $imgs = $loader.querySelectorAll('.loader-element__img img');

    if ( $imgs.length ) {
        let activeIndex = [...$imgs].findIndex($img => $img.classList.contains('active'));
        if ( activeIndex < 0 ) activeIndex = 0;

        clearInterval($loader._imgCycle);

        $loader._imgCycle = setInterval(() => {
            $imgs[activeIndex].classList.remove('active');
            activeIndex = (activeIndex + 1) % $imgs.length;
            $imgs[activeIndex].classList.add('active');
        }, 400);
    }
}

export function globalLoaderElementImgsStop($loader) {
    if (!$loader) return;

    $loader.classList.add('load-complete');

    setTimeout(() => {
        clearInterval($loader._imgCycle);
        $loader._imgCycle = null;
        $loader.classList.add('removed');
    }, 500);
}
